export default __webpack_public_path__ + "static/media/A5_32.ca50c3af.mp3";